import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  InputBase,
  Box,
  IconButton,
  Button,
  FormControlLabel,
} from "@material-ui/core";
import { useMediaQuery, Typography } from "@material-ui/core";
import fakedata from "./fakedata";
import RePortDashboard from "./ReportDashboard";
import { useSelector } from "react-redux";
import { darkTheme, lightTheme } from "../layout/themes";
import GridContent from "./GridContent";
import ListContent from "./ListContent";
import {
  useDataProvider,
  Loading,
  usePermissions,
  Title,
  useTranslate,
} from "react-admin";
import CreateClusterDialog from "./CreateClusterDialog";
import icList from "../assets/icons/primary-blue-sort-list.png";
import icGrid from "../assets/icons/primary-blue-sort-card.png";
import Snackbar from '../common/snackbar';
import icListGrey from "../assets/icons/grayscale-4-sort-list.png";
import icGridGrey from "../assets/icons/grayscale-4-sort-card.png";
import icSearch from "../assets/icons/grayscale-3-search.png";
import SnackBarCustom from "../users/snackbar";
import { useLocation } from "react-router-dom";
import { totalmem } from "os";
import { ArrowBackIosRounded } from "@material-ui/icons";
import Search from "../search";
import ResultSearchRoom from "../CustomizedUIs/ResultSearchRoom";
import CustomSwitch from "../CustomizedUIs/GreenSwitch";
import axios from 'axios';
import { baseApiUrl } from '../dataProvider/sails';
import ResultSearchCluster from "../CustomizedUIs/ResultSearchCluster";

const useStyles = makeStyles((theme) => ({
  searchPaper: {
    padding: "5px 10px",
    display: "flex",
    alignItems: "center",
    margin: "auto 0",
    width: "236px",
    boxShadow: "none",
  },
  searchIcon: {
    width: "18px",
    marginRight: "10px",
    opacity: 0.5,
  },
  input: {
    marginLeft: "9.7px",
    width: 236,
    flex: 1,
    fontFamily: "UniviaPro-Book",
    fontSize: "12px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#88898c",
    "&::placeholder": {
      color: "#88898c",
      opacity: 1,
    },
  },
  iconButton: {
    padding: 10,
  },
  borderSearch: {
    borderRadius: "10px",
    border: " solid 1px #e0f0f2",
    backgroundColor: " #ffffff",
  },
  TitleDashboard: {
    fontFamily: "UniviaPro-Medium",
    fontSize: "18px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.2,
    letterSpacing: "normal",
    color: "#4f5064",
  },
  TitleAddCluster: {
    fontFamily: "UniviaPro-Bold",
    fontSize: "10px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.4px",
    color: "#4f5064",
  },
  btnSearchRoom: {
    fontFamily: "UniviaPro-Bold",
    fontSize: "9px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.22,
    letterSpacing: "0.36px",
    color: theme.palette.primary.main,
    padding: 4,
  },
}));

const formatperent = (array) => {
  var tempdiff = 0;
  var total = 0;
  array.forEach((item) => (total += item[1]));
  array.map((item) => {
    item[1] = (item[1] / total) * 100;
    tempdiff += Math.floor(item[1]);
    return item;
  });
  var diff = 100 - tempdiff;
  array.sort(function (a, b) {
    return b[1] - Math.floor(b[1]) - (a[1] - Math.floor(a[1]));
  });
  var obj = {};
  array.forEach((item) => {
    if (diff > 0) {
      item[1] = item[1] + 1;
      diff--;
    }
    obj[item[0].replace(" ", "").toLowerCase()] = Math.floor(item[1]);
  });
  return obj;
};

export default (props) => {
  const theme = useSelector((state) =>
    state.theme == "dark" ? darkTheme : lightTheme
  );
  const { permissions, loaded } = usePermissions();
  const classes = useStyles();
  const [isGrid, setIsGrid] = useState(true);
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const isXsmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const [data, setData] = useState([]);
  const [openCreate, setOpenCreate] = useState(false);
  const [filter, setFilter] = useState("");
  const [loading, setLoading] = useState(true);
  const [loadingReport, setLoadingReport] = useState(false);
  const [tvUsage, setTvUsage] = useState([]);
  const [error, setError] = useState();
  const dataProvider = useDataProvider();
  const translate = useTranslate();
  const location = useLocation();
  const [openedit, setOpenEdit] = React.useState(false);
  const [searchRoom, setSearchRoom] = useState(false);
  const [messageSnackbar, setMessageSnackbar] = useState({ name: '', message: '' });
  const [showSnackbar, setShowSnackbar] = useState(false)

  const callReport = () => {
    setLoadingReport(true);
    dataProvider("GET_LIST", "usage-data/get-tv-summarize", {
      filter: {
        cluster: [],
        userID: JSON.parse(localStorage.getItem("userData")).user.id,
      },
      pagination: {},
      sort: {},
    })
      .then(({ data }) => {
        let arrayData = data.detail;
        arrayData.splice(0, 1);
        setTvUsage(formatperent(arrayData));
        setLoadingReport(false);
      })
      .catch((error) => {
        console.log(error);
        // setError(error);
        setLoadingReport(false);
      });
  };
  useEffect(() => {
    if (!openCreate) {
      dataProvider("GET_LIST", "ClusterAssign", {
        filter: {},
        pagination: {},
        sort: { field: "name", order: "ASC" },
      })
        .then(({ data }) => {
          setData(data);
          setLoading(false);
        })
        .catch((error) => {
          setError(error);
          setLoading(false);
        });
      callReport();
    }

  }, [openCreate]);

  if (loading || loadingReport) return <Loading />;
  if (error) return null;
  if (!data) return null;
  if (!loaded) return null;

  const handleViewType = () => {
    setIsGrid(!isGrid);
  };
  const fileBrowserOnChange = event => {
    var files = [...event.target.files]
    if (files && files.length === 1) {
      var file = files[0];
      if (file.type === 'application/vnd.ms-excel' || file.type === 'text/csv') {
        console.log('import channel fileBrowserOnChange', file);
        setLoading(true);
        const formData = new FormData();
        formData.append('file', file);
        axios
          .post(`${baseApiUrl}/room/import`, formData)
          .then(response => {
            setMessageSnackbar({ name: "Import sucess:", message: `${file.name} is imported succesfully.` });
            setShowSnackbar(true);
            setTimeout(() => {
              setShowSnackbar(false);
            }, 6000);
            dataProvider("GET_LIST", "ClusterAssign", {
              filter: {},
              pagination: {},
              sort: { field: "name", order: "ASC" },
            })
              .then(({ data }) => {
                setData(data);
                setLoading(false);
              })
              .catch((error) => {
                setError(error);
                setLoading(false);
              });
            setLoading(false);
          })
          .catch(error => {
            console.error('Import csv file error:', error.message, error.response);
            let errMessage = (error.response && error.response.data) ? error.response.data.message : error.message;
            setMessageSnackbar({ name: "Import error:", message: errMessage });
            setShowSnackbar(true);
            setTimeout(() => {
              setShowSnackbar(false);
            }, 6000);
            file.error = true;
            setLoading(false);
          });
      }
      else {
        setMessageSnackbar({ name: "Import error:", message: "Only accept csv file" });
        setShowSnackbar(true);
        setTimeout(() => {
          setShowSnackbar(false);
        }, 6000);
        file.error = true;
      }
    }
  }
  const searchOnChange = (e) => {
    setFilter(e.target.value);
  };

  const clickAddCluster = () => {
    setOpenCreate(true);
  };

  const handelCloseDialog = () => {
    setOpenCreate(false);
  };
  const handleCloseEdit = () => {
    setOpenEdit(!openedit);
  };

  const handleChangeToSearchRoom = () => {
    setSearchRoom((prev) => !prev);
  };

  return (
    <Box width="100%">
      {location.state !== undefined && location.state.cluster != undefined && (
        <SnackBarCustom
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          message={`${location.state.cluster.name} deleted!`}
          open={location.state.openMessage ? !openedit : openedit}
          handleClose={() => handleCloseEdit()}
        />
      )}
      <Title title={translate(`pos.dashboard.title`)} />
      <Box
        width="100%"
        m="auto"
        py={2}
        style={{ backgroundColor: "rgba(255, 255, 255, 0.7)" }}
      >
        <RePortDashboard data={data} tvUsage={tvUsage} />
      </Box>

      <Box width={!isDesktop ? "95%" : "80%"} m="auto">
        <Box my={2}>
          <Snackbar
            show={showSnackbar}
            boldText={(location.state && location.state.name) || messageSnackbar.name}
            message={location.state && location.state.message || messageSnackbar.message}
            onClose={() => setShowSnackbar(false)}
          />
          <Box my={3}>
            <Typography className={classes.TitleDashboard}>
              {translate(`pos.dashboard.title`)}
            </Typography>
          </Box>
          <Box display="flex">
            <Box my="auto" display="flex" alignItems="center">

              <Box
                borderRadius="10px"
                className={classes.borderSearch}
                mr={2}
              >
                <Paper component="form" className={classes.searchPaper}>
                  <img
                    src={icSearch}
                    width={17.6}
                    height={17.6}
                    style={{ marginLeft: "10.7px" }}
                  />
                  <InputBase
                    placeholder={translate(`pos.dashboard.searchEntity`)}
                    inputProps={{
                      "aria-label": "search",
                      className: classes.input,
                    }}
                    onChange={searchOnChange}
                  />
                </Paper>
              </Box>
              {searchRoom ? (
                <ResultSearchRoom
                  textHolder={translate(`resources.room.search`)}
                />
              ) : (
                <ResultSearchCluster
                  textHolder={translate(`pos.dashboard.search`)}
                />
              )}
              <Box
                alignItems="center"
                display="flex"
                style={{
                  padding: "6px 8px",
                  borderRadius: "0",
                  backgroundColor: "#ffffff",
                  borderRadius: "10px",
                  border: "1px solid #e0f0f2",
                }}
              >
                <Typography className={classes.btnSearchRoom}>
                  {translate(`resources.room.search`).toUpperCase()}
                </Typography>
                <CustomSwitch
                  size="small"
                  onChange={handleChangeToSearchRoom}
                />
              </Box>
            </Box>
            <Box
              flexGrow={1}
              my="auto"
              display="flex"
              justifyContent="flex-end"
            >
              {permissions?.functionAction.find(
                (value) => value.function === "CRUD Cluster" && value.isCreate
              ) && (
                  <Button className={classes.TitleAddCluster} style={{ textTransform: "none" }} onClick={() => clickAddCluster()}>
                    {translate(`pos.dashboard.addCluster`)}
                  </Button>
                )}
              <Box
                my="auto"
                display="flex"
                justifyContent="center">
                <input style={{ display: 'none' }} id="contained-button-file" type='file' onChange={fileBrowserOnChange} className={classes.input} accept=".csv" />
                <label htmlFor="contained-button-file">
                  <Button className={classes.TitleAddCluster} style={{ textTransform: "none" }} component="span">
                    {translate("pos.dashboard.importCSV")}
                  </Button>
                </label>
              </Box>
              <Box display="flex" justifyContent="flex-end" my="auto">
                <IconButton
                  style={{
                    backgroundColor: !isGrid
                      ? theme.palette.background.paper
                      : "#fafefe",
                    borderRadius: "4px 0 0 4px",
                    padding: "6px 9px 8px 9px",
                  }}
                  disabled={!isGrid}
                  onClick={handleViewType}
                  size="small"
                >
                  {isGrid ? (
                    <img src={icListGrey} width={16.6} height={16.6} />
                  ) : (
                    <img src={icList} height={16.6} width={16.6} />
                  )}
                </IconButton>
                <IconButton
                  style={{
                    marginLeft: 1,
                    backgroundColor: isGrid
                      ? theme.palette.background.paper
                      : "#fafefe",
                    borderRadius: "0 4px 4px 0",
                    padding: "6px 9px 8px 9px",
                  }}
                  disabled={isGrid}
                  onClick={handleViewType}
                  size="small"
                >
                  {!isGrid ? (
                    <img src={icGridGrey} width={16.6} height={16.6} />
                  ) : (
                    <img src={icGrid} height={16.6} width={16.6} />
                  )}
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box>
          {isGrid ? (
            <GridContent filter={filter} data={data.countResult} />
          ) : (
            <ListContent filter={filter} data={data.countResult} />
          )}
        </Box>
      </Box>
      <CreateClusterDialog
        {...props}
        open={openCreate}
        handleClose={handelCloseDialog}
        dataRecever={data}
      />
    </Box>
  );
};
export { formatperent };
